import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import clsx from 'clsx';
import { IconLoader, LinkItem, LogoutIcon, MaterialLinkItem, NavigationWrapper } from './components';
import useIsMobile from '../components/useIsMobile';
import useMobileActiveMenu from '../components/useMobileActiveMenu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { GetAccountSettings } from '@themes/common/data';
const { customers_account_logout } = GetAccountSettings().translations;
export default function AccountNavigations({ menuItems }) {
    const location = useLocation();
    const isMoble = useIsMobile();
    const [mobileMenuState, setActive] = useMobileActiveMenu();
    return !mobileMenuState.activePath || !isMoble ? (_jsx(NavigationWrapper, Object.assign({ className: clsx({
            mobile: isMoble,
        }) }, { children: _jsxs(Stack, { children: [menuItems.map((item) => (_jsxs(LinkItem, Object.assign({ to: item.url, onClick: () => {
                        setActive((state) => {
                            state.activePath = item.url;
                        });
                    }, className: clsx({
                        active: location.pathname === item.url && !isMoble,
                        mobile: isMoble,
                        'edit-page': item.url.includes('/edit'),
                    }), "data-no-instant": true }, { children: [_jsx(IconLoader, { src: item.icon, active: location.pathname === item.url }), " ", item.text, isMoble && _jsx(ChevronRightIcon, { sx: { marginLeft: 'auto' } })] }), item.id))), _jsxs(MaterialLinkItem, Object.assign({ href: '/account/logout', className: clsx({
                        mobile: isMoble,
                    }), "data-no-instant": true }, { children: [_jsx(LogoutIcon, {}), customers_account_logout, isMoble && _jsx(ChevronRightIcon, { sx: { marginLeft: 'auto' } })] }))] }) }))) : (_jsx(_Fragment, {}));
}
